/**
 * Swiper Slider for Similar Products
 * Desktop: 4 slides, Tablet: 3 slides, Mobile: 2 slides
 */

class SwiperProductSlider extends HTMLElement {
  connectedCallback() {
    if (typeof Swiper === 'undefined') {
      console.error('Swiper library not loaded');
      return;
    }

    this.initSwiper();
  }

  initSwiper() {
    const container = this.querySelector('.swiper');
    if (!container) return;

    this.swiper = new Swiper(container, {
      slidesPerView: 2,
      spaceBetween: 16,
      navigation: {
        nextEl: this.querySelector('.swiper-button-next'),
        prevEl: this.querySelector('.swiper-button-prev'),
      },
      breakpoints: {
        750: {
          slidesPerView: 3,
          spaceBetween: 16
        },
        990: {
          slidesPerView: 4,
          spaceBetween: 16
        }
      },
      on: {
        init: (swiper) => {
          this.updateProgressBar(swiper);
        },
        slideChange: (swiper) => {
          this.updateProgressBar(swiper);
        },
        resize: (swiper) => {
          this.updateProgressBar(swiper);
        }
      }
    });
  }

  updateProgressBar(swiper) {
    const progressBar = this.querySelector('.swiper-progress-bar-fill');
    if (!progressBar) return;

    const slidesPerView = swiper.params.slidesPerView;
    const totalSlides = swiper.slides.length;
    const activeIndex = swiper.activeIndex;

    if (slidesPerView >= totalSlides) {
      progressBar.style.width = '100%';
      progressBar.style.left = '0%';
      return;
    }

    const progressWidth = (slidesPerView / totalSlides) * 100;
    const maxScroll = totalSlides - slidesPerView;
    const scrollPercentage = maxScroll > 0 ? (activeIndex / maxScroll) : 0;
    const progressLeft = scrollPercentage * (100 - progressWidth);

    progressBar.style.width = `${Math.min(progressWidth, 100)}%`;
    progressBar.style.left = `${Math.min(Math.max(progressLeft, 0), 100 - progressWidth)}%`;
  }

  disconnectedCallback() {
    if (this.swiper) {
      this.swiper.destroy(true, true);
    }
  }
}

if (!customElements.get('swiper-product-slider')) {
  customElements.define('swiper-product-slider', SwiperProductSlider);
}
